
export default {
  name: "the-redirect-loader",
  props: {
    returnUrl: {
      required: false,
      default: "",
    },
    layout: {
      required: false,
      default: "chain",
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {
    formattedUrl() {
      var a = document.createElement("a");
      a.href = this.returnUrl;
      return a.hostname;
    },
  },
};
